/* React */
import React from "react";

/* Stylesheet */
import styles from "./PageLayoutWrapper.module.scss";

/* Interfaces */
interface PageLayoutWrapperProps {
  children: React.ReactNode;
  scssProps?: ScssProps;
}

interface ScssProps {
  padding?: string;
  height?: string;
}

const PageLayoutWrapper: React.FC<
  PageLayoutWrapperProps
> = ({ children, scssProps }) => {
  return (
    <div
      style={{
        padding: scssProps?.padding,
        height: scssProps?.height,
      }}
      className={styles.page_layout_wrapper}
    >
      {children}
    </div>
  );
};

export default PageLayoutWrapper;
